<ng-container *ngIf="seatMap as seatMap">
  <ng-container *ngFor="let cabin of seatMap?.Cabins">
    <ng-container *ngFor="let rowType of cabin.Wings">
      <div class="box-wing {{rowType.Type}} {{rowType.WingType}}" [class.large]="isLarge" [ngSwitch]="rowType.WingType">
        <ng-container *ngSwitchCase="wingTypes.Initial">
          <div class="line-top"></div>
          <div class="line-center"></div>
        </ng-container>
        <ng-container *ngSwitchCase="wingTypes.Normal">
          <div class="line-center"></div>
        </ng-container>
        <ng-container *ngSwitchCase="wingTypes.Final">
          <div class="line-center"></div>
          <div class="line-top"></div>
        </ng-container>
        <ng-container *ngSwitchCase="wingTypes.Title">
          <span class="title-wing">{{'SEAT_MAP_MODULE.WINGS'|transloco}}</span>
        </ng-container>
        <ng-container *ngSwitchCase="wingTypes.Exit">
          <div class="exit" [class.right]="orientationRight">
            <i aria-hidden="true" class="icon-arrow-drop-up top"></i>
            <i aria-hidden="true" class="icon-arrow-drop-up bottom"></i>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</ng-container>